import { create } from 'zustand';
/** Mirrors economyStore's exact pattern. */
export const economySyncStore = create()(() => ({
    pendingCount: 0,
}));
